import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'

@Component({
  selector: 'app-notify-automation-delayed',
  templateUrl: './notify-automation-delayed.component.html',
  styleUrls: ['./notify-automation-delayed.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotifyAutomationDelayedComponent implements OnInit {
  @Input() ctrl: UntypedFormControl

  @Input() min = 0
  @Input() max = 36
  @Input() hidePlaceholder = false
  @Input() showLabel = true

  @Input() disabled = false

  constructor() {}

  ngOnInit(): void {}
}
